import { Link } from "react-router-dom";
import styles from "./NotFound.module.css";
import unfound from "../../Images/404.png"

function NotFound() {
    return (
        <div styles={`${styles.content} ${styles.notfound}`}>
            <div className={styles.notfound}>
                <img src={unfound} alt="404" />
                <Link to="/">Voltar para o início</Link>
            </div>
        </div>
    )
}

export default NotFound;